import * as React from 'react';
import ProductColourVariation from '../../interface/ProductColourVariation';
import ColourSwatchesGroup from './ColourSwatchesGroup';

interface ColourVariationsProps {
    productHandle: string
    colourVariations: ProductColourVariation[]
    outOfStockTitle: string
    outOfStockMessage: string
}

const ColourVariations = (props: ColourVariationsProps) => {
    const { productHandle, colourVariations, outOfStockTitle, outOfStockMessage } = props;
    if (colourVariations.length > 0) {
        //Sort by colour
        colourVariations.sort((a, b) => (a.colour > b.colour) ? 1 : -1);

        let colourSwatches = colourVariations.filter((colour: any) => colour ? colour.colour : false ).map((colour: any) => {
            return {
                title: colour.colour,
                value: colour.handle,
                href: '/products/'+colour.handle,
                swatchImage: colour.colourSwatchImage ? colour.colourSwatchImage : null,
                selected: colour.handle === productHandle ? true : false,
                available: colour.available,
                outOfStockTitle: outOfStockTitle,
                outOfStockMessage: outOfStockMessage,
                onClick: (handle: string) => {
                    if (handle !== productHandle) {
                        window.location.href = `/products/${handle}`;
                    }
                }
            }
        });
        if (colourSwatches.length > 0) {
            return <ColourSwatchesGroup option="Colour" type="colour" swatches={colourSwatches}/>           
        }
    }
    return (<></>);
}
export default ColourVariations;